// @flow strict

// by default we will cut 1.5x although devicePixelRatio might be more than 1.5 (it seems to be a good balance between quality and size)
const MINIMUM_DEVICE_PIXEL_RATIO = 1.5;

/** calculate how big we would like our image to be to fill and look good in the container */
const getDevicePixelRatio = (getImageBasedOnClientInfo: boolean) => {
  // eslint-disable-next-line no-restricted-globals
  if (typeof window !== 'undefined' && window.devicePixelRatio && getImageBasedOnClientInfo) {
    // eslint-disable-next-line no-restricted-globals
    return Math.min(window.devicePixelRatio, MINIMUM_DEVICE_PIXEL_RATIO);
  }
  return MINIMUM_DEVICE_PIXEL_RATIO;
};

export default getDevicePixelRatio;
